export default __webpack_public_path__ + "static/integration-00462e270d67fb59894c33c15bab0457.svg";